import { useCallback, useEffect, useState } from 'react'
import { Button, Card, DatePicker, Descriptions, Divider, Form, Input, InputNumber, Modal, Select, Space, TableProps, Tag, Tooltip } from 'antd'
import { DeleteOutlined, DownloadOutlined, EditOutlined, PrinterOutlined, SearchOutlined, UndoOutlined } from '@ant-design/icons'
import CustomTable from '../../components/table'
import defaultParams, { FORMAT_DATE, TRANSACTION_CONNECTION_TYPE_CONNECTION, TRANSACTION_CONNECTION_TYPE_EXTENSION } from '../../assets/constants/default_params'
import { useLoading } from '../../context/LoadingContext'
import { apiAddInvoice, apiAddInvoiceAdapterByInvoiceId, apiDeleteInvoice, apiGetListCompanies, apiGetListInvoiceTemplateItems, apiGetListInvoiceTemplates, apiGetListInvoices, apiGetListPackageDiscount, apiGetListPackagesConnection, apiGetListPhoneAgencies, apiGetListTransactionConnection, apiGetListUsers, apiGetPrintInvoiceAdapter, apiUpdateDataPackTransactionConnection, apiUpdateFailedTransactionConnection, apiUpdateInvoice, apiUpdateListSimTransactionConnection, apiUpdatePhoneNumberTransactionConnection } from '../../api'
import { filterOptionByLabel } from '../../utils/filter-utils'
import { mbhStatusOptions, transactionConnectionDiscountsOptions, transactionConnectionTypeOptions } from '../../assets/constants/default_options'
import { ICompany } from '../../models/company.modal'
import { renderDateByUnix, renderType } from './method'
import { IUser } from '../../models/user.model'
import { formatCurrency } from '../../utils/string-utils'
import { toastError, toastSuccess } from '../../utils/toast'
import { useSelector } from 'react-redux'
import { authSelector } from '../../redux/slices/authSlice'
import { IPartnerPackage } from '../../models/package.modal'
import dayjs from 'dayjs'
import * as XLSX from "xlsx"
import { saveAs } from "file-saver"
import { renderDiscount } from '../package/partner'
import { renderInvoiceStatus } from '../invoice/history'
import moment from 'moment'

export const renderProductNature = (type: number) => {
    switch (type) {
        case 1: return 'Hàng hóa dịch vụ'
        case 2: return 'Khuyến mại'
        case 3: return 'Chiết khấu thương mại'
        case 4: return 'Ghi chú/ diễn giải'
        case 5: return 'Hàng hóa đăc trưng'
        default: return 'Không xác định'
    }
}

export default function KitSimOrder() {
    const [companyOptions, setCompanyOptions] = useState<{ label: string, value: Number }[]>([])
    const [userOptions, setUserOptions] = useState<{ label: string, value: Number }[]>([])
    const [transactionConnection, setTransactionConnection] = useState<any>({})
    const [invoiceTemplates, setInvoiceTemplates] = useState<any>([])
    const [invoiceTemplateItems, setInvoiceTemplateItems] = useState<any>([])
    const [agencies, setAgencies] = useState<any>([])
    const [invoices, setInvoices] = useState<any>([])
    const [currentPage, setCurrentPage] = useState<number>(defaultParams.PAGE)
    const [pageSize, setPageSize] = useState<number>(defaultParams.LIMIT)
    const [search, setSearch] = useState<any>({})
    const [modalUpdateListSim, setModalUpdateListSim] = useState<any>({ isOpen: false, data: null })
    const [updateListSimValue, setUpdateListSimValue] = useState<any>({ phoneSim: '', serialSim: '' })
    const [modalUpdatePhoneNumber, setModalUpdatePhoneNumber] = useState<any>({ isOpen: false, data: null })
    const [updatePhoneNumberValue, setUpdatePhoneNumberValue] = useState<any>({ phoneAgency: '', phoneCustomer: '' })
    const [modalUpdateDataPack, setModalUpdateDataPack] = useState<any>({ isOpen: false, data: null })
    const [updateDataPackValue, setUpdateDataPackValue] = useState<any>({ cpCode: '', dataPack: '', startDate: null })
    const [modalUpdateFailed, setModalUpdateFailed] = useState<any>({ isOpen: false, data: null })
    const [modalInvoiceExport, setModalInvoiceExport] = useState<any>({ isOpen: false, data: null })
    const [invoiceExportValue, setInvoiceExportValue] = useState<any>({ customer_name: '', invoice_template_id: 0 })
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const [cpCode, setCpCode] = useState<string>('')
    const [partnerPackageOptions, setPartnerPackageOptions] = useState<{ label: string, value: Number }[]>([])
    const [packageDiscount, setPackageDiscount] = useState<any>([])
    const [showModalConfirmExport, setShowModalConfirmExport] = useState<boolean>(false)
    const [showModalConfirmUpdate, setShowModalConfirmUpdate] = useState<boolean>(false)
    const [modalUpdateInvoice, setModalUpdateInvoice] = useState<any>({ isOpen: false, data: null })
    const [modalDeleteInvoice, setModalDeleteInvoice] = useState<any>({ isOpen: false, data: null })
    const { setIsLoading } = useLoading()
    const [formSearch] = Form.useForm()
    const { account } = useSelector(authSelector)

    const transactionConnectionColumns: TableProps<any>['columns'] = [
        {
            key: 'cpCode',
            title: 'Mã công ty',
            dataIndex: 'cpCode',
        },
        {
            key: 'ownerBy',
            title: 'Nhân sự đấu nối',
            dataIndex: 'ownerBy',
        },
        {
            key: 'phoneAgency',
            title: 'SĐT báo KH',
            dataIndex: 'phoneAgency',
            render: phoneAgency => phoneAgency ? agencies.find((agen: any) => agen.id === phoneAgency)?.phoneAgency : '',
        },
        {
            key: 'phoneSim',
            title: 'Msisdn',
            dataIndex: 'phoneSim',
        },
        {
            key: 'serialSim',
            title: 'Serial Sim',
            dataIndex: 'serialSim',
        },
        {
            key: 'phoneCustomer',
            title: 'SĐT Khách hàng',
            dataIndex: 'phoneCustomer',
        },
        {
            key: 'dataPack',
            title: 'Gói cước',
            dataIndex: 'dataPack',
        },
        {
            key: 'price',
            title: 'Giá',
            dataIndex: 'price',
            render: price => (
                <span style={{ whiteSpace: 'nowrap' }}>
                    {formatCurrency(price)}
                </span>
            ),
        },
        {
            key: 'startDate',
            title: 'Ngày đấu nối',
            dataIndex: 'startDate',
            render: startDate => (
                <span style={{ whiteSpace: 'nowrap' }}>
                    {renderDateByUnix(startDate)}
                </span>
            ),
        },
        {
            key: 'endDate',
            title: 'Ngày hết hạn',
            dataIndex: 'endDate',
            render: endDate => (
                <span style={{ whiteSpace: 'nowrap' }}>
                    {renderDateByUnix(endDate)}
                </span>
            ),
        },
        {
            key: 'type',
            title: 'Loại gói cước',
            dataIndex: 'type',
            render: type => renderType(type),
        },
        {
            key: 'discounts',
            title: 'Khuyến mãi',
            dataIndex: 'discounts',
            render: discounts => discounts ? renderDiscounts(discounts) : '',
        },
        {
            key: 'customer_name',
            title: 'Khách hàng',
            render: data => {
                const invoice = invoices.find((inv: any) => inv.tran_id === data.id)
                return invoice ? invoice.customer_name : null
            },
        },
        {
            key: 'invoice',
            title: 'Trạng thái HĐ',
            render: data => {
                const invoice = invoices.find((inv: any) => inv.tran_id === data.id)
                return invoice ? renderInvoiceStatus(invoice.status) : null
            },
        },
        {
            key: 'created_at',
            title: 'Thời gian tạo',
            render: data => {
                const invoice = invoices.find((inv: any) => inv.tran_id === data.id)
                return invoice ? moment(invoice.created_at).format('DD/MM/YYYY HH:mm:ss') : null
            },
        },
        (
            account?.isAdmin
            || account?.canUpdatePhoneNumberTransactionConnection
            || account?.canUpdateDataPackTransactionConnection
            || account?.canUpdatePhoneSim
            || account?.canGetListInvoices
        ) ? {
            key: 'update',
            title: 'Cập nhật',
            render: data => {
                const invoice = invoices.find((inv: any) => inv.tran_id === data.id)
                return (
                    <Space>
                        {(account?.isAdmin || account?.canUpdatePhoneSim) && (
                            <Tooltip title="Cập nhật thông tin sim">
                                <Button size='small' onClick={() => {
                                    setUpdateListSimValue({ phoneSim: data.phoneSim, serialSim: data.serialSim })
                                    setModalUpdateListSim({ isOpen: true, data })
                                }}>
                                    Sim
                                </Button>
                            </Tooltip>
                        )}
                        {account?.canUpdatePhoneNumberTransactionConnection && (
                            <Tooltip title="Cập nhật thông tin SĐT">
                                <Button size='small' onClick={() => {
                                    setUpdatePhoneNumberValue({
                                        phoneAgency: data.phoneAgency ? agencies.find((agen: any) => agen.id === data.phoneAgency)?.phoneAgency : '',
                                        phoneCustomer: data.phoneCustomer,
                                    })
                                    setModalUpdatePhoneNumber({ isOpen: true, data })
                                }}>
                                    SĐT
                                </Button>
                            </Tooltip>
                        )}
                        {account?.canUpdateDataPackTransactionConnection && (
                            <Tooltip title="Cập nhật thông tin gói cước">
                                <Button size='small' onClick={() => {
                                    setCpCode(data.cpCode)
                                    setUpdateDataPackValue({
                                        cpCode: data.cpCode,
                                        dataPack: `${data.dataPack}::${data.type}::${data.price}`,
                                        startDate: dayjs(renderDateByUnix(data.startDate)),
                                    })
                                    setModalUpdateDataPack({ isOpen: true, data })
                                }}>
                                    Gói cước
                                </Button>
                            </Tooltip>
                        )}
                        {account?.canUpdateFailedTransactionConnection && data.status === 'SUCCESS' && (
                            <Button size='small' disabled={data.status !== 'SUCCESS'} onClick={() => {
                                setModalUpdateFailed({ isOpen: true, data })
                            }}>
                                Xoá
                            </Button>
                        )}
                        {account?.canGetListInvoices && (
                            <Tooltip title="Thông tin hoá đơn">
                                <Button
                                    size='small'
                                    type={invoice ? 'primary' : 'default'}
                                    style={!invoice ? {} : invoice?.status === 'SUCCESS' ? { backgroundColor: '#52c41a', borderColor: '#52c41a' } :
                                        invoice?.status === 'CREATED' ? {} : { backgroundColor: '#f5222d', borderColor: '#f5222d' }}
                                    onClick={() => setModalInvoiceExport({ isOpen: true, data: { ...data, invoice } })}
                                    icon={<PrinterOutlined />}
                                />
                            </Tooltip>
                        )}
                    </Space>
                )
            },
        } : {},
    ]

    const invoiceTemplateItemsColumns: TableProps<any>['columns'] = [
        {
            key: 'product_line_number',
            title: 'STT',
            dataIndex: 'product_line_number',
        },
        {
            key: 'description',
            title: 'Tên hàng hoá',
            dataIndex: 'description',
        },
        {
            key: 'unit',
            title: 'Đơn vị',
            dataIndex: 'unit',
        },
        {
            key: 'quantity',
            title: 'Số lượng',
            dataIndex: 'quantity',
        },
        {
            key: 'unit_price',
            title: 'Đơn giá',
            dataIndex: 'unit_price',
            render: unit_price => formatCurrency(unit_price),
        },
        {
            key: 'product_nature',
            title: 'Loại sản phẩm',
            dataIndex: 'product_nature',
            render: product_nature => renderProductNature(product_nature),
        },
    ]

    const renderDiscounts = (discounts: any) => {
        const discountIds = discounts.split(',')
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {discountIds.map((discountId: any) => {
                    const discount = packageDiscount.find((disc: any) => Number(disc.id) === Number(discountId))
                    return (
                        <Tag color='red'>
                            {renderDiscount(discount.price_type, discount.discount_type, discount.discount_value)}
                        </Tag>
                    )
                })}
            </div>
        )
    }

    const fetchPhoneAgencies = useCallback(async (trans: any) => {
        const idAgencies = [] as string[]
        trans.map((tran: any) => {
            if (tran.phoneAgency && !idAgencies.includes(tran.phoneAgency)) {
                idAgencies.push(`'${tran.phoneAgency}'`)
            }
            return tran
        })
        if (idAgencies.length > 0) {
            const respAgency = await apiGetListPhoneAgencies({
                page: 1,
                size: idAgencies.length,
                condition: `"cpCode" = '${search.cpCode}' AND  id IN (${idAgencies.toString()})`
            })
            setAgencies(respAgency.data.phoneAgencies)
        }
    }, [search.cpCode])

    const fetchInvoices = useCallback(async (trans: any) => {
        if (!account?.canGetListInvoices) return
        const idTrans = [] as string[]
        trans.map((tran: any) => {
            idTrans.push(`'${tran.id}'`)
            return tran
        })
        if (idTrans.length > 0) {
            const respInvoice = await apiGetListInvoices({
                page: 1,
                size: idTrans.length,
                condition: `"cpCode" = '${search.cpCode}' AND tran_id IN (${idTrans.toString()})`
            })
            setInvoices(respInvoice.data.invoices)
        }
    }, [search.cpCode])

    const fetchTransactionConnection = useCallback(async () => {
        if (!search.cpCode && !search.ownerBy && !search.type && !search.status && !search.phoneSim && !search.serialSim && !search.phoneCustomer && !search.price && !search.discounts) {
            setTransactionConnection({})
            return
        }
        try {
            setIsLoading(true)
            if (!search.status) {
                search.status = 'SUCCESS'
            }
            const resp = await apiGetListTransactionConnection({
                page: currentPage,
                size: pageSize,
                ...search,
            })
            if (resp.status === 200) {
                fetchPhoneAgencies(resp.data.transactions)
                fetchInvoices(resp.data.transactions)
                setTransactionConnection(resp.data)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }, [setIsLoading, fetchPhoneAgencies, currentPage, pageSize, search])

    const fetchCompanies = useCallback(async () => {
        try {
            const resp = await apiGetListCompanies({ limit: defaultParams.MAX_LIMIT })
            if (resp.data != null) {
                const options = resp.data.companies.map((item: ICompany) => ({
                    label: item.name,
                    value: item.code,
                }))
                setCompanyOptions(options)
            } else {
                setCompanyOptions([])
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchPartnerPackages = useCallback(async () => {
        if (!cpCode) return
        try {
            const resp = await apiGetListPackagesConnection(cpCode)
            if (resp.data?.partner_packages === null) {
                return
            }
            const options = resp.data.partner_packages.map((item: IPartnerPackage) => {
                let label = item.name
                let value = `${item.code}::${item.type}::${item.price}`
                if (item.type === TRANSACTION_CONNECTION_TYPE_CONNECTION) {
                    label += '_Đấu mới'
                }
                if (item.type === TRANSACTION_CONNECTION_TYPE_EXTENSION) {
                    label += '_Gia hạn'
                }
                return { label, value }
            })
            setPartnerPackageOptions(options)
        } catch (error) {
            console.log(error)
        }
    }, [cpCode])

    const fetchPackageDiscounts = useCallback(async () => {
        try {
            const { data } = await apiGetListPackageDiscount({
                page: defaultParams.PAGE,
                size: defaultParams.MAX_LIMIT,
            })
            setPackageDiscount(data.packageDiscount)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchUsers = useCallback(async () => {
        try {
            const resp = await apiGetListUsers({ limit: defaultParams.MAX_LIMIT })
            if (resp.data != null) {
                const options = resp.data.users.map((item: IUser) => ({
                    label: item.username,
                    value: item.username,
                }))
                setUserOptions(options)
            } else {
                setUserOptions([])
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchInvoiceTemplates = useCallback(async () => {
        if (!account?.canGetListInvoiceTemplates) return
        try {
            const respInvoice = await apiGetListInvoiceTemplates()
            setInvoiceTemplates(respInvoice.data.templates)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchInvoiceTemplateItems = useCallback(async () => {
        if (!account?.canGetListInvoiceTemplateItems) return
        try {
            const respInvoice = await apiGetListInvoiceTemplateItems()
            setInvoiceTemplateItems(respInvoice.data.items)
        } catch (error) {
            console.log(error)
        }
    }, [])

    useEffect(() => {
        fetchCompanies()
        fetchPartnerPackages()
        fetchPackageDiscounts()
        fetchUsers()
        fetchInvoiceTemplates()
        fetchInvoiceTemplateItems()
    }, [fetchCompanies, fetchPartnerPackages, fetchPackageDiscounts, fetchUsers, fetchInvoiceTemplates, fetchInvoiceTemplateItems])

    useEffect(() => {
        fetchTransactionConnection()
    }, [fetchTransactionConnection])

    const handleSearch = ({ cpCode, ownerBy, type, status, phoneSim, serialSim, phoneCustomer, date, price, discounts }: any) => {
        if (!cpCode && !ownerBy && !type && !status && !phoneSim && !serialSim && !phoneCustomer && !price && !discounts) return
        let startDate, endDate
        if (date) {
            startDate = date[0] ? date[0]?.format('YYYY-MM-DD') : null
            endDate = date[1] ? date[1]?.format('YYYY-MM-DD') : null
        }
        if (cpCode) setCpCode(cpCode)
        setSearch({ cpCode, ownerBy, type, status, phoneSim, serialSim, phoneCustomer, startDate, endDate, price, discounts })
        setCurrentPage(defaultParams.PAGE)
        setPageSize(defaultParams.LIMIT)
    }

    const handleClearSearch = () => {
        formSearch.resetFields()
        setSearch({})
        setCurrentPage(defaultParams.PAGE)
        setPageSize(defaultParams.LIMIT)
    }

    const handleUpdateListSim = async () => {
        try {
            if (!updateListSimValue.phoneSim || !updateListSimValue.serialSim) {
                toastError('Vui lòng điền đầy đủ thông tin!')
                return
            }
            setIsLoading(true)
            const { data } = await apiUpdateListSimTransactionConnection({
                id: modalUpdateListSim.data.id,
                phoneSim: updateListSimValue.phoneSim,
                serialSim: updateListSimValue.serialSim,
            })
            if (data.status !== '200') {
                toastError(data.message)
                return
            }
            fetchTransactionConnection()
            setModalUpdateListSim({ isOpen: false, data: null })
            toastSuccess('Cập nhật thông tin thành công!')
        } catch (error) {
            toastError('Có lỗi xảy ra!')
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdatePhoneNumber = async () => {
        try {
            if (!updatePhoneNumberValue.phoneAgency && !updatePhoneNumberValue.phoneCustomer) {
                toastError('Vui lòng điền đầy đủ thông tin!')
                return
            }
            setIsLoading(true)
            const { data } = await apiUpdatePhoneNumberTransactionConnection({
                id: modalUpdatePhoneNumber.data.id,
                phoneAgency: updatePhoneNumberValue.phoneAgency,
                phoneCustomer: updatePhoneNumberValue.phoneCustomer,
            })
            if (data.status !== '200') {
                toastError(data.message)
                return
            }
            fetchTransactionConnection()
            setModalUpdatePhoneNumber({ isOpen: false, data: null })
            toastSuccess('Cập nhật thông tin thành công!')
        } catch (error) {
            toastError('Có lỗi xảy ra!')
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateDataPack = async () => {
        try {
            if (!updateDataPackValue.cpCode || !updateDataPackValue.dataPack || !updateDataPackValue.startDate) {
                toastError('Vui lòng điền đầy đủ thông tin!')
                return
            }
            setIsLoading(true)
            const dataPack = updateDataPackValue.dataPack.split('::')
            const startDate = dayjs(updateDataPackValue.startDate).format(FORMAT_DATE)
            const { data } = await apiUpdateDataPackTransactionConnection({
                id: modalUpdateDataPack.data.id,
                cpCode: updateDataPackValue.cpCode,
                dataPack: dataPack[0],
                packType: dataPack[1],
                startDate: startDate,
            })
            if (data.status !== '200') {
                toastError(data.message)
                return
            }
            fetchTransactionConnection()
            setModalUpdateDataPack({ isOpen: false, data: null })
            toastSuccess('Cập nhật thông tin thành công!')
        } catch (error) {
            toastError('Có lỗi xảy ra!')
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateFailed = async () => {
        try {
            setIsLoading(true)
            const { data } = await apiUpdateFailedTransactionConnection({
                id: modalUpdateFailed.data.id,
            })
            if (data.status !== '200') {
                toastError(data.message)
                return
            }
            fetchTransactionConnection()
            setModalUpdateFailed({ isOpen: false, data: null })
            toastSuccess('Cập nhật thông tin thành công!')
        } catch (error) {
            toastError('Có lỗi xảy ra!')
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    const handleDownloadExcel = async () => {
        try {
            setIsLoading(true)
            const dataExcel = transactionConnection.transactions?.map((item: any) => ({
                id: item.id,
                cpCode: item.cpCode,
                ownerBy: item.ownerBy,
                phoneSim: item.phoneSim,
                serialSim: item.serialSim,
                phoneCustomer: item.phoneCustomer,
                dataPack: item.dataPack,
                numberDay: item.numberDay,
                type: item.type,
                price: item.price,
                startDate: dayjs(item.startDate * 1000).format('YYYY-MM-DD'),
                endDate: dayjs(item.endDate * 1000).format('YYYY-MM-DD'),
                status: item.status,
                createdAt: item.createdAt,
                updatedAt: item.updatedAt,
                phoneAgency: item.phoneAgency,
                isuse: item.isuse,
                discounts: item.discounts,
            }))
            const ws = XLSX.utils.json_to_sheet(dataExcel)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1")
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" })
            const blob = new Blob([excelBuffer], { type: "application/octet-stream" })
            saveAs(blob, 'transaction_connection.xlsx')
            toastSuccess('Đã tải xuống!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleInvoiceExport = async () => {
        try {
            if (!invoiceExportValue.customer_name || !invoiceExportValue.invoice_template_id) {
                toastError('Vui lòng điền đầy đủ thông tin!')
                return
            }
            setIsLoading(true)
            await apiAddInvoice({
                tran_id: modalInvoiceExport.data.id,
                customer_name: invoiceExportValue.customer_name.toUpperCase(),
                invoice_template_id: invoiceExportValue.invoice_template_id,
            })
            fetchTransactionConnection()
            setModalInvoiceExport({ isOpen: false, data: null })
            setInvoiceExportValue({ customer_name: '', invoice_template_id: 0 })
            setShowModalConfirm(false)
            toastSuccess('Xuất hóa đơn nháp thành công!')
        } catch (error) {
            toastError('Có lỗi xảy ra!')
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    const handleInvoiceExportAdapter = async () => {
        try {
            if (modalInvoiceExport.data?.invoice?.status !== 'CREATED') {
                toastError('Hoá đơn phải được tạo nháp trước khi xuất!')
                return
            }
            setIsLoading(true)
            await apiAddInvoiceAdapterByInvoiceId({
                id: modalInvoiceExport.data?.invoice?.id,
            })
            fetchInvoices(transactionConnection.transactions)
            setShowModalConfirmExport(false)
            setModalInvoiceExport({ isOpen: false, data: null })
            toastSuccess('Xuất hóa đơn thành công!')
        } catch (error) {
            toastError('Có lỗi xảy ra!')
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    const handleInvoicePrint = async () => {
        try {
            if (modalInvoiceExport.data?.invoice?.status !== 'SUCCESS') {
                toastError('Hóa đơn chưa xuất, vui lòng xuất hóa đơn trước khi tải về!')
                return
            }
            setIsLoading(true)
            const resp = await apiGetPrintInvoiceAdapter({
                id: modalInvoiceExport.data.invoice.invoice_id
            })
            saveAs(resp.data, modalInvoiceExport.data.invoice.invoice_id + ".pdf");
            toastSuccess('Đã tải xuống!')
        } catch (error) {
            toastError('Có lỗi xảy ra!')
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleInvoiceUpdate = async () => {
        try {
            if (!invoiceExportValue.customer_name || !invoiceExportValue.invoice_template_id) {
                toastError('Vui lòng điền đầy đủ thông tin!')
                return
            }
            setIsLoading(true)
            await apiUpdateInvoice({
                invoice: {
                    id: modalInvoiceExport.data?.invoice?.id,
                    tran_id: modalInvoiceExport.data?.invoice?.tran_id,
                    customer_name: invoiceExportValue.customer_name?.trim().toUpperCase(),
                    invoice_template_id: invoiceExportValue.invoice_template_id,
                }
            })
            fetchInvoices(transactionConnection.transactions)
            setShowModalConfirmUpdate(false)
            setModalInvoiceExport({ isOpen: false, data: null })
            setModalUpdateInvoice({ isOpen: false, data: null })
            setInvoiceExportValue({ customer_name: '', invoice_template_id: 0 })
            toastSuccess('Cập nhật hóa đơn nháp thành công!')
        } catch (error) {
            toastError('Có lỗi xảy ra!')
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    const handleDeleteInvoice = async () => {
        try {
            setIsLoading(true)
            await apiDeleteInvoice({ invoice: modalDeleteInvoice.data })
            setModalInvoiceExport({ isOpen: false, data: null })
            setModalDeleteInvoice({ isOpen: false, data: null })
            setInvoiceExportValue({ customer_name: '', invoice_template_id: 0 })
            fetchInvoices(transactionConnection.transactions)
            toastSuccess('Xoá hóa đơn thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div>
            <Form form={formSearch} onFinish={handleSearch}>
                <div style={{ display: 'flex', alignItems: 'start', flexWrap: 'wrap', gap: 20 }}>
                    <Form.Item name='cpCode' label='Công ty'
                        rules={[{ required: true, message: 'Vui lòng chọn công ty' }]}>
                        <Select
                            style={{ minWidth: 170 }}
                            showSearch
                            placeholder="Chọn công ty"
                            options={companyOptions}
                            filterOption={filterOptionByLabel}
                        />
                    </Form.Item>
                    <Form.Item name='ownerBy' label='Nhân sự đấu nối'>
                        <Select
                            style={{ minWidth: 170 }}
                            showSearch
                            placeholder="Chọn nhân sự"
                            options={userOptions}
                            filterOption={filterOptionByLabel}
                        />
                    </Form.Item>
                    <Form.Item name='type' label='Loại giao dịch'>
                        <Select
                            style={{ width: 170 }}
                            showSearch
                            placeholder="Chọn loại giao dịch"
                            options={transactionConnectionTypeOptions}
                            filterOption={filterOptionByLabel}
                        />
                    </Form.Item>
                    <Form.Item name='status' label='Trạng thái'>
                        <Select
                            style={{ width: 170 }}
                            showSearch
                            defaultValue={'SUCCESS'}
                            options={mbhStatusOptions}
                            filterOption={filterOptionByLabel}
                        />
                    </Form.Item>
                    <Form.Item name='phoneCustomer' label='SĐT Khách hàng'>
                        <Input autoComplete='off' />
                    </Form.Item>
                    <Form.Item name='phoneSim' label='Msisdn'>
                        <Input autoComplete='off' />
                    </Form.Item>
                    <Form.Item name='serialSim' label='SerialSim'>
                        <Input autoComplete='off' />
                    </Form.Item>
                    <Form.Item name="date" label="Ngày đấu nối">
                        <DatePicker.RangePicker
                            format="YYYY-MM-DD"
                            picker="date" />
                    </Form.Item>
                    <Form.Item name='discounts' label='Khuyến mãi'>
                        <Select
                            style={{ width: 170 }}
                            showSearch
                            placeholder="Chọn loại khuyến mãi"
                            options={transactionConnectionDiscountsOptions}
                            filterOption={filterOptionByLabel}
                        />
                    </Form.Item>
                    <Form.Item name='price' label='Giá'>
                        <InputNumber style={{ width: 170 }} />
                    </Form.Item>
                    <Space style={{ marginBottom: 24 }}>
                        <Button type='primary' htmlType="submit" icon={<SearchOutlined />}>Tìm kiếm</Button>
                        <Button onClick={handleClearSearch} icon={<UndoOutlined />}></Button>
                    </Space>
                </div>
            </Form>
            <CustomTable
                namePage='giao dịch'
                columns={transactionConnectionColumns}
                dataSource={transactionConnection.transactions}
                pageSize={pageSize}
                setPageSize={setPageSize}
                total={transactionConnection.total}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />
            <Button
                onClick={handleDownloadExcel}
                style={{ margin: 20 }}
                disabled={Number(transactionConnection.transactions?.length || 0) === 0}
            >
                Export ({Number(transactionConnection.transactions?.length || 0)})
            </Button>
            <Modal
                title='Cập nhật thông tin sim'
                open={modalUpdateListSim.isOpen}
                footer={null}
                onCancel={() => setModalUpdateListSim({ isOpen: false, data: null })}>
                <Divider />
                <div style={{ marginBottom: 20 }}>
                    <div style={{ marginBottom: 10 }}>Msisdn</div>
                    <Input
                        value={updateListSimValue.phoneSim}
                        onChange={e => setUpdateListSimValue({ ...updateListSimValue, phoneSim: e.target.value })}
                    />
                </div>
                <div style={{ marginBottom: 20 }}>
                    <div style={{ marginBottom: 10 }}>Serial Sim</div>
                    <Input
                        disabled={!account?.isAdmin}
                        value={updateListSimValue.serialSim}
                        onChange={e => setUpdateListSimValue({ ...updateListSimValue, serialSim: e.target.value })}
                    />
                </div>
                <div style={{ textAlign: 'right' }}>
                    <Button onClick={handleUpdateListSim} type='primary' htmlType='submit'>Cập nhật</Button>
                </div>
            </Modal>
            <Modal
                title='Cập nhật thông tin số điện thoại'
                open={modalUpdatePhoneNumber.isOpen}
                footer={null}
                onCancel={() => setModalUpdatePhoneNumber({ isOpen: false, data: null })}>
                <Divider />
                <div style={{ marginBottom: 20 }}>
                    <div style={{ marginBottom: 10 }}>SĐT Đại lý</div>
                    <Input
                        value={updatePhoneNumberValue.phoneAgency}
                        onChange={e => setUpdatePhoneNumberValue({ ...updatePhoneNumberValue, phoneAgency: e.target.value })}
                    />
                </div>
                <div style={{ marginBottom: 20 }}>
                    <div style={{ marginBottom: 10 }}>SĐT Khách hàng</div>
                    <Input
                        value={updatePhoneNumberValue.phoneCustomer}
                        onChange={e => setUpdatePhoneNumberValue({ ...updatePhoneNumberValue, phoneCustomer: e.target.value })}
                    />
                </div>
                <div style={{ textAlign: 'right' }}>
                    <Button onClick={handleUpdatePhoneNumber} type='primary' htmlType='submit'>Cập nhật</Button>
                </div>
            </Modal>
            <Modal
                title='Cập nhật thông tin gói cước'
                open={modalUpdateDataPack.isOpen}
                footer={null}
                onCancel={() => setModalUpdateDataPack({ isOpen: false, data: null })}>
                <Divider />
                <div style={{ marginBottom: 20 }}>
                    <div style={{ marginBottom: 10 }}>Công ty</div>
                    <Select
                        value={updateDataPackValue.cpCode}
                        onChange={value => {
                            setCpCode(value)
                            setUpdateDataPackValue({ ...updateDataPackValue, cpCode: value })
                        }}
                        style={{ width: '100%' }}
                        showSearch
                        options={companyOptions}
                        filterOption={filterOptionByLabel}
                    />
                </div>
                <div style={{ marginBottom: 20 }}>
                    <div style={{ marginBottom: 10 }}>Gói cước</div>
                    <Select
                        value={updateDataPackValue.dataPack}
                        onChange={value => setUpdateDataPackValue({ ...updateDataPackValue, dataPack: value })}
                        style={{ width: '100%' }}
                        showSearch
                        options={partnerPackageOptions}
                        filterOption={filterOptionByLabel}
                    />
                </div>
                <div style={{ marginBottom: 20 }}>
                    <div style={{ marginBottom: 10 }}>Ngày đấu nối</div>
                    <DatePicker
                        style={{ width: '100%' }}
                        value={updateDataPackValue.startDate}
                        onChange={value => setUpdateDataPackValue({ ...updateDataPackValue, startDate: value })}
                        format={FORMAT_DATE}
                        placeholder='Ngày bắt đầu'
                        picker='date'
                    />
                </div>
                <div style={{ textAlign: 'right' }}>
                    <Button onClick={handleUpdateDataPack} type='primary' htmlType='submit'>Cập nhật</Button>
                </div>
            </Modal>
            <Modal
                title='Cập nhật thất bại cho giao dịch'
                open={modalUpdateFailed.isOpen}
                footer={null}
                onCancel={() => setModalUpdateFailed({ isOpen: false, data: null })}>
                <Divider />
                <p>Bạn có chắc chắn muốn cập nhật thất bại cho giao dịch này?</p>
                <p><b>Msisdn:</b> {modalUpdateFailed.data?.phoneSim}</p>
                <p><b>Serial Sim:</b> {modalUpdateFailed.data?.serialSim}</p>
                <p><b>Ngày đấu:</b> {renderDateByUnix(modalUpdateFailed.data?.startDate)}</p>
                <p style={{ color: 'red' }}>Lưu ý: Hành động này không thể hoàn tác!</p>
                <div style={{ textAlign: 'right' }}>
                    <Button onClick={handleUpdateFailed} type='primary' danger htmlType='submit'>Xoá</Button>
                </div>
            </Modal>
            {modalInvoiceExport.data?.invoice ? (
                <Modal
                    width={'64%'}
                    title='Thông tin hóa đơn'
                    open={modalInvoiceExport.isOpen}
                    footer={null}
                    onCancel={() => setModalInvoiceExport({ isOpen: false, data: null })}>
                    <Divider />
                    <div>
                        <Descriptions
                            items={[
                                {
                                    key: 'phoneSim',
                                    label: 'Msisdn',
                                    children: modalInvoiceExport.data?.phoneSim,
                                },
                                {
                                    key: 'serialSim',
                                    label: 'Serial Sim',
                                    children: modalInvoiceExport.data?.serialSim,
                                },
                            ]}
                        />
                        <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <b>Khách hàng:</b>
                            <span>{modalInvoiceExport.data?.invoice.customer_name}</span>
                        </p>
                        <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <b>Gói cước:</b>
                            <span>{modalInvoiceExport.data?.dataPack}</span>
                        </p>
                        <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <b>Giá:</b>
                            <span>{formatCurrency(Number(modalInvoiceExport.data?.price))}</span>
                        </p>
                        <Card size='small' style={{ marginTop: 10 }}>
                            {invoiceTemplates.filter((config: any) => config.id === modalInvoiceExport.data?.invoice.invoice_template_id).map((config: any, index: number) => (
                                <div key={index}>
                                    <Descriptions
                                        items={[
                                            {
                                                key: 'cpCode',
                                                label: 'Đối tác',
                                                children: config?.cpCode,
                                            },
                                            {
                                                key: 'network',
                                                label: 'Network',
                                                children: config?.network,
                                            },
                                            {
                                                key: 'invoice_series',
                                                label: 'Mẫu số',
                                                children: config?.invoice_series,
                                            },
                                            {
                                                key: 'tran_amount',
                                                label: 'Số tiền giao dịch',
                                                children: formatCurrency(config?.tran_amount),
                                            },
                                            {
                                                key: 'total_amount',
                                                label: 'Tổng số tiền',
                                                children: formatCurrency(config?.total_amount),
                                            },
                                            {
                                                key: 'tax_rate',
                                                label: 'Thuế suất',
                                                children: config?.tax_rate + '%',
                                            },
                                            {
                                                key: 'currency_code',
                                                label: 'Loại tiền tệ',
                                                children: config?.currency_code,
                                            },
                                            {
                                                key: 'exchange_rate',
                                                label: 'Tỷ giá',
                                                children: config?.exchange_rate,
                                            },
                                            {
                                                key: 'payment_method_name',
                                                label: 'Hình thức thanh toán',
                                                children: config?.payment_method_name,
                                            },
                                            {
                                                key: 'alias',
                                                label: 'Tên template',
                                                children: config?.alias,
                                            },
                                        ]}
                                    />
                                    <CustomTable
                                        namePage='sản phẩm'
                                        columns={invoiceTemplateItemsColumns}
                                        dataSource={invoiceTemplateItems?.filter((i: any) => i.invoice_template_id === config?.id)}
                                        total={invoiceTemplateItems?.filter((i: any) => i.invoice_template_id === config?.id)?.length}
                                        isHiddenPagination={true}
                                    />
                                </div>
                            ))}
                        </Card>
                    </div>
                    <Divider />
                    <div style={{ textAlign: 'right' }}>
                        {modalInvoiceExport.data?.invoice.status === 'SUCCESS' ? (
                            invoiceTemplates.find((config: any) => config.id === modalInvoiceExport.data?.invoice?.invoice_template_id)?.network === 'OTEK-MISA-QUICK' ? <></> :
                                <Button disabled={!account?.canGetPrintInvoiceAdapter} type='primary' onClick={handleInvoicePrint} icon={<DownloadOutlined />}>Tải xuống</Button>
                        ) : modalInvoiceExport.data?.invoice.status === 'CREATED' ? (
                            <Space>
                                <Button disabled={!account?.canAddInvoiceAdapterByInvoiceId} type='primary' onClick={() => setShowModalConfirmExport(true)} icon={<PrinterOutlined />}>Xuất</Button>
                                <Button disabled={!account?.canUpdateInvoice} onClick={() => {
                                    setModalUpdateInvoice({ isOpen: true, data: modalInvoiceExport.data?.invoice })
                                    setInvoiceExportValue({
                                        customer_name: modalInvoiceExport.data?.invoice.customer_name,
                                        invoice_template_id: modalInvoiceExport.data?.invoice.invoice_template_id
                                    })
                                }} icon={<EditOutlined />}>Sửa</Button>
                                <Button danger disabled={!account?.canDeleteInvoice} onClick={() => {
                                    setModalDeleteInvoice({ isOpen: true, data: modalInvoiceExport.data?.invoice })
                                }} icon={<DeleteOutlined />}>Xoá</Button>
                            </Space>
                        ) : <></>}
                    </div>
                </Modal>
            ) : (
                <Modal
                    title='Tạo hoá hóa đơn nháp'
                    open={modalInvoiceExport.isOpen}
                    footer={null}
                    onCancel={() => {
                        setModalInvoiceExport({ isOpen: false, data: null })
                        setInvoiceExportValue({ customer_name: '', invoice_template_id: 0 })
                    }}>
                    <Divider />
                    <div>
                        <Descriptions
                            items={[
                                {
                                    key: 'phoneSim',
                                    label: 'Msisdn',
                                    children: modalInvoiceExport?.data?.phoneSim,
                                },
                                {
                                    key: 'serialSim',
                                    label: 'Serial Sim',
                                    children: modalInvoiceExport?.data?.serialSim,
                                },
                            ]}
                        />
                        <div style={{ marginBottom: 10 }}>Họ và tên KH</div>
                        <Input
                            value={invoiceExportValue.customer_name}
                            onChange={e => setInvoiceExportValue({ ...invoiceExportValue, customer_name: e.target.value })}
                        />
                        <div style={{ marginTop: 10 }}>
                            <div style={{ marginBottom: 10 }}>Chọn loại hoá đơn</div>
                            <Select
                                style={{ width: '100%' }}
                                value={invoiceExportValue.invoice_template_id}
                                onChange={value => setInvoiceExportValue({ ...invoiceExportValue, invoice_template_id: value })}
                                options={invoiceTemplates.filter((config: any) => config.cpCode === search.cpCode).map((config: any) => ({
                                    label: config.alias,
                                    value: config.id,
                                }))}
                            />
                        </div>
                    </div>
                    <Divider />
                    <div style={{ textAlign: 'right' }}>
                        <Button disabled={!account?.canAddInvoice} type='primary' onClick={() => {
                            if (!invoiceExportValue.customer_name || !invoiceExportValue.invoice_template_id) {
                                toastError('Vui lòng điền đầy đủ thông tin!')
                                return
                            }
                            setShowModalConfirm(true)
                        }}>Xuất nháp</Button>
                    </div>
                </Modal>
            )}
            <Modal
                width={'64%'}
                title='Xác nhận xuất hoá đơn nháp' open={showModalConfirm}
                onCancel={() => setShowModalConfirm(false)}
                footer={[
                    <Button onClick={handleInvoiceExport}
                        style={{ background: '#008965', color: 'white' }}>
                        Xác nhận
                    </Button>,
                    <Button onClick={() => setShowModalConfirm(false)}
                        style={{ background: 'gray', color: 'white' }}>
                        Đóng
                    </Button>,
                ]}>
                <Divider />
                <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <b>Khách hàng:</b>
                    <span>{invoiceExportValue.customer_name}</span>
                </p>
                <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <b>Gói cước:</b>
                    <span>{modalInvoiceExport.data?.dataPack}</span>
                </p>
                <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <b>Giá:</b>
                    <span>{formatCurrency(Number(modalInvoiceExport.data?.price))}</span>
                </p>
                <Card size='small' style={{ marginTop: 10 }}>
                    {invoiceTemplates.filter((config: any) => config.id === invoiceExportValue.invoice_template_id).map((config: any, index: number) => (
                        <div key={index}>
                            <Descriptions
                                items={[
                                    {
                                        key: 'cpCode',
                                        label: 'Đối tác',
                                        children: config?.cpCode,
                                    },
                                    {
                                        key: 'total_amount',
                                        label: 'Tổng số tiền',
                                        children: formatCurrency(config?.total_amount),
                                    },
                                    {
                                        key: 'tax_rate',
                                        label: 'Thuế suất',
                                        children: config?.tax_rate + '%',
                                    },
                                    {
                                        key: 'invoice_series',
                                        label: 'Mẫu số',
                                        children: config?.invoice_series,
                                    },
                                    {
                                        key: 'currency_code',
                                        label: 'Loại tiền tệ',
                                        children: config?.currency_code,
                                    },
                                    {
                                        key: 'exchange_rate',
                                        label: 'Tỷ giá',
                                        children: config?.exchange_rate,
                                    },
                                    {
                                        key: 'payment_method_name',
                                        label: 'Hình thức thanh toán',
                                        children: config?.payment_method_name,
                                    },
                                ]}
                            />
                            <CustomTable
                                namePage='sản phẩm'
                                columns={invoiceTemplateItemsColumns}
                                dataSource={invoiceTemplateItems?.filter((i: any) => i.invoice_template_id === config?.id)}
                                total={invoiceTemplateItems?.filter((i: any) => i.invoice_template_id === config?.id)?.length}
                                isHiddenPagination={true}
                            />
                        </div>
                    ))}
                </Card>
                <Divider />
            </Modal>
            <Modal
                title='Xác nhận xuất hoá đơn' open={showModalConfirmExport}
                onCancel={() => setShowModalConfirmExport(false)}
                footer={[
                    <Button onClick={handleInvoiceExportAdapter}
                        style={{ background: '#008965', color: 'white' }}>
                        Xác nhận
                    </Button>,
                    <Button onClick={() => setShowModalConfirmExport(false)}
                        style={{ background: 'gray', color: 'white' }}>
                        Đóng
                    </Button>,
                ]}>
                <Divider />
                {invoiceTemplates.filter((config: any) => config.id === modalInvoiceExport.data?.invoice?.invoice_template_id).map((config: any, index: number) => (
                    <p key={index}>Xuất hoá đơn <b>{config?.alias}</b> cho khách hàng <b>{modalInvoiceExport.data?.invoice?.customer_name}</b></p>
                ))}
                <Divider />
            </Modal>
            <Modal
                title='Cập nhật hóa đơn'
                open={modalUpdateInvoice.isOpen}
                footer={null}
                onCancel={() => setModalUpdateInvoice({ isOpen: false, data: null })}>
                <Divider />
                <div>
                    <div style={{ marginBottom: 10 }}>Họ và tên KH</div>
                    <Input
                        value={invoiceExportValue.customer_name}
                        onChange={e => setInvoiceExportValue({ ...invoiceExportValue, customer_name: e.target.value })}
                    />
                    <div style={{ marginTop: 10 }}>
                        <div style={{ marginBottom: 10 }}>Chọn loại hoá đơn</div>
                        <Select
                            style={{ width: '100%' }}
                            value={invoiceExportValue.invoice_template_id}
                            onChange={value => setInvoiceExportValue({ ...invoiceExportValue, invoice_template_id: value })}
                            options={invoiceTemplates.filter((config: any) => config.cpCode === modalInvoiceExport.data?.cpCode).map((config: any) => ({
                                label: config.alias,
                                value: config.id,
                            }))}
                        />
                    </div>
                </div>
                <Divider />
                <div style={{ textAlign: 'right' }}>
                    <Button type='primary' onClick={() => setShowModalConfirmUpdate(true)}>Cập nhật</Button>
                </div>
            </Modal>
            <Modal
                title='Xác nhận cập nhật hoá đơn' open={showModalConfirmUpdate}
                onCancel={() => setShowModalConfirmUpdate(false)}
                footer={[
                    <Button onClick={handleInvoiceUpdate}
                        style={{ background: '#008965', color: 'white' }}>
                        Xác nhận
                    </Button>,
                    <Button onClick={() => setShowModalConfirmUpdate(false)}
                        style={{ background: 'gray', color: 'white' }}>
                        Đóng
                    </Button>,
                ]}>
                <Divider />
                {invoiceTemplates.filter((config: any) => config.id === invoiceExportValue?.invoice_template_id).map((config: any, index: number) => (
                    <p key={index}>Cập nhật hoá đơn <b>{config?.alias}</b> cho khách hàng <b>{invoiceExportValue?.customer_name}</b></p>
                ))}
                <Divider />
            </Modal>
            <Modal
                title='Xoá hoá đơn'
                open={modalDeleteInvoice.isOpen}
                footer={null}
                onCancel={() => setModalDeleteInvoice({ isOpen: false, data: null })}>
                <Divider />
                {invoiceTemplates.filter((config: any) => config.id === modalDeleteInvoice.data?.invoice_template_id).map((config: any, index: number) => (
                    <p key={index}>Bạn muốn xoá hoá đơn <b>{config?.alias}</b> cho khách hàng <b>{modalDeleteInvoice.data?.customer_name}</b></p>
                ))}
                <div style={{ textAlign: 'right' }}>
                    <Button type='primary' danger onClick={handleDeleteInvoice}>Xoá</Button>
                </div>
            </Modal>
        </div>
    )
}
